import React, { useCallback } from 'react';
import Quiz from '../quiz/Quiz';
import { useSelector, useDispatch } from 'react-redux';
import { selectVideoQuizzes, takeQuiz, passQuiz } from './videoQuizzesSlice';
import { VideoPlayer } from '@rcm/vimeo-player';
import t from 'rcm-i18n';
import { VideoWithQuizStepConfig } from '../../types';
import './VideoQuiz.scss';
interface Props {
    videoWithQuizStep: VideoWithQuizStepConfig;
    stepIndex: number;
    onContinueToNextStep: () => void;
}

const VideoQuiz = (props: Props) => {
    const videoQuizzesState = useSelector(selectVideoQuizzes);
    const dispatch = useDispatch();

    const handleTakeQuizButtonClick = useCallback(
        () => {
            dispatch(takeQuiz(props.stepIndex));
        },
        [props.stepIndex]
    );

    const handlePassQuiz = useCallback(
        () => {
            dispatch(passQuiz(props.stepIndex));
        },
        [props.stepIndex]
    );

    const takingQuiz = videoQuizzesState
        .stepIndexesThatStartedTakingQuiz.includes(props.stepIndex);

    const passedQuiz = videoQuizzesState
        .stepIndexesWhereQuizWasPassed.includes(props.stepIndex);
    const video = props.videoWithQuizStep.video;
    return <div>
        <div className="video-quiz-video-and-content-wrap">
            <VideoPlayer video={video} />
            {props.videoWithQuizStep.belowVideoHtml &&
                <div className="video-quiz-below-video-body" dangerouslySetInnerHTML={{ __html: props.videoWithQuizStep.belowVideoHtml }} />
            }
        </div>
        {passedQuiz &&
            <>
                <div className="alert alert-success" role="alert">
                    {t('Your answers were correct!')}
                </div>
                {props.videoWithQuizStep.postQuizBody && props.videoWithQuizStep.postQuizBody.length > 0 &&
                    <div className="post-quiz-body"
                        dangerouslySetInnerHTML={{ __html: props.videoWithQuizStep.postQuizBody }} />
                }
                <button className="btn btn-primary" onClick={props.onContinueToNextStep}>
                    {t('Continue')}
                </button>
            </>
        }
        {!passedQuiz && takingQuiz &&
            <Quiz quizQuestions={props.videoWithQuizStep.quizQuestions}
                onPassedQuiz={handlePassQuiz} />
        }
        {!passedQuiz && !takingQuiz &&
            <button className="btn btn-primary" onClick={handleTakeQuizButtonClick}>{t('Take Quiz')}</button>
        }
    </div>;
};

export default VideoQuiz;
